import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "children", "ref"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import styled from 'styled-components';
import { textLinkStyles } from 'components/TextLink';
import { visuallyHidden } from 'styles/mixins';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var FileInput = styled.input.attrs({
  type: 'file'
}).withConfig({
  displayName: "FileInputLink__FileInput",
  componentId: "sc-1cq6kfc-0"
})(["", ""], visuallyHidden);
var TextLinkLabel = styled.label.withConfig({
  displayName: "FileInputLink__TextLinkLabel",
  componentId: "sc-1cq6kfc-1"
})(["", " cursor:pointer;input:focus + &{outline:3px solid currentColor;outline-offset:3px;text-decoration:underline;}"], textLinkStyles);
function FileInputLink(_ref) {
  var id = _ref.id,
    children = _ref.children,
    ref = _ref.ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FileInput, _objectSpread({
      ref: ref,
      id: id
    }, otherProps)), /*#__PURE__*/_jsx(TextLinkLabel, {
      htmlFor: id,
      children: children
    })]
  });
}
FileInputLink.displayName = 'FileInputLink';
export default FileInputLink;